import * as Sentry from '@sentry/react'

export const logError = e => {
  console.error(e)
  Sentry.captureException(e)
}
